import { GzExchangeProtectionAntiSpoofingContainerWebComponent } from './component/GzExchangeProtectionAntiSpoofingContainerWebComponent';

export { GzExchangeProtectionAntiSpoofingContainerWebComponent };
